import React from "react"

const Fbmessenger = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0001 1.66663C5.30008 1.66663 1.66675 5.10829 1.66675 9.74996C1.66675 12.175 2.65841 14.2833 4.28341 15.725C4.41675 15.8333 4.50008 16.0166 4.50841 16.2L4.55008 17.6833C4.58341 18.1583 5.05841 18.4666 5.49175 18.275L7.14175 17.55C7.28341 17.5 7.44175 17.475 7.58342 17.5C8.33342 17.725 9.16675 17.8333 10.0001 17.8333C14.7001 17.8333 18.3334 14.3916 18.3334 9.74996C18.3334 5.10829 14.7001 1.66663 10.0001 1.66663ZM15.0001 7.88329L12.5584 11.775C12.1667 12.3833 11.3334 12.5416 10.7501 12.0833L8.80008 10.6416C8.71353 10.5767 8.60827 10.5416 8.50008 10.5416C8.3919 10.5416 8.28663 10.5767 8.20008 10.6416L5.56675 12.6416C5.21675 12.9166 4.75841 12.5 5.00008 12.1166L7.44175 8.22496C7.83342 7.61663 8.66675 7.45829 9.25008 7.89163L11.2001 9.35829C11.2866 9.4232 11.3919 9.45829 11.5001 9.45829C11.6083 9.45829 11.7135 9.4232 11.8001 9.35829L14.4334 7.35829C14.7834 7.08329 15.2417 7.49996 15.0001 7.88329Z"
        fill="white" />
    </svg>
  )
}

export default Fbmessenger
